<div class="date-picker-container" [class.disabled]="disabled">
  <div class="date-picker-content" [class.required]="required">
    <label class="date-picker-label">{{ label }}</label>

    <!-- Mode Selection -->
    <div class="mode-selector">
      <mat-button-toggle-group [(ngModel)]="value.mode" (change)="onModeChange()" [disabled]="disabled">
        <mat-button-toggle value="relative">Relative</mat-button-toggle>
        <mat-button-toggle value="specific">Specific</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <!-- Relative Date Selection -->
    <div class="relative-date-section" *ngIf="value.mode === 'relative'">
      <mat-form-field appearance="outline" class="relative-select">
        <mat-label>Relative Date</mat-label>
        <mat-select [(ngModel)]="value.value" (selectionChange)="onRelativeValueChange()" [disabled]="disabled">
          <mat-option *ngFor="let option of relativeDateOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Custom Relative Date Input -->
      <div class="custom-relative-input" *ngIf="isCustomMode()">
        <mat-form-field appearance="outline" class="custom-value">
          <mat-label>Value</mat-label>
          <input matInput type="number" [(ngModel)]="customValue" (ngModelChange)="onCustomValueChange()" [disabled]="disabled" (click)="$event.stopPropagation()">
        </mat-form-field>

        <mat-form-field appearance="outline" class="custom-unit">
          <mat-label>Unit</mat-label>
          <mat-select [(ngModel)]="selectedCustomUnit" (selectionChange)="onCustomUnitChange()" [disabled]="disabled" (click)="$event.stopPropagation()">
            <mat-option *ngFor="let unit of customRelativeOptions" [value]="unit.value">
              {{ unit.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Specific Date Selection -->
    <div class="specific-date-section" *ngIf="value.mode === 'specific'">
      <mat-form-field appearance="outline" class="specific-date">
        <mat-label>Specific Date</mat-label>
        <input matInput [matDatepicker]="picker"
               [value]="value.value"
               (dateChange)="onSpecificDateChange($event)"
               [min]="minDate"
               [max]="maxDate"
               [disabled]="disabled"
               placeholder="Choose a date"
               (click)="$event.stopPropagation()">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Display Value -->
    <div class="display-value" *ngIf="getDisplayValue()">
      <span class="calculated-date" *ngIf="getCalculatedDate()">
        Calculated: {{ getCalculatedDate() | date:'mediumDate' }}
      </span>
    </div>

    <div class="error-message" *ngIf="required && !getCalculatedDate() && !value.value">
      Date is required
    </div>
  </div>
</div>
